export default __webpack_public_path__ + "static/media/humid.7e5f5351.png";